<template>
  <div id="signup_container" class="columns">
    <div class="column is-centered">
      <Signup></Signup>
    </div>
    <div class="column is-centered">
      <infoPanel></infoPanel>
    </div>
  </div>
</template>

<script>
import Signup from "@/components/Signup.vue";
import infoPanel from "@/components/infoPanel.vue";

export default {
  name: "signup",
  components: {
    Signup,
    infoPanel
  }
};
</script>

<style scoped>
#signup_container {
  background: #f7f7f7;
}
</style>
